import { m } from 'framer-motion';
//
import Logo from './Logo';

// ----------------------------------------------------------------------
// Tela de carregamento.
//
// Refeita em 13/08/2026 (comentario original, mantido - a logica nao mudou
// nesta migracao, so a implementacao trocou de MUI `styled`/`sx` para CSS
// simples + tokens --gps-*):
//
//   1. Superficie neutra (--gps-bg), sem gradiente. Espera nao e momento de
//      destaque visual: quanto menos ruido, menor a sensacao de demora.
//   2. Movimento SUTIL e continuo - um halo que respira e uma barra
//      indeterminada. Animacao lenta demais parece travada; rapida demais
//      parece nervosa. 1.8s no halo e o meio.
//   3. O texto explica o que se espera, nao o obvio. "Carregando..." nao informa;
//      "Preparando seu painel" diz o que vem a seguir.
//
// A cor do halo/anel usa var(--gps-accent) puro (sem alpha - nao ha token de
// alpha para isso e a regra da migracao veta inventar um). O alpha 0.22/0.28
// que a versao MUI misturava na COR (`alpha(primary.main, 0.22)`) foi para
// dentro dos proprios arrays de `animate.opacity` abaixo (0.5*0.22=0.11 etc.):
// o framer-motion ja anima opacidade do elemento inteiro, entao multiplicar
// ali reproduz o mesmo brilho maximo sem precisar de duas fontes de opacidade
// competindo (opacity de `style` seria ignorada mesmo, o framer assume o
// controle da propriedade que ele anima).
// ----------------------------------------------------------------------

export default function LoadingScreen() {
  return (
    <div
      style={{
        right: 0,
        bottom: 0,
        zIndex: 99999,
        width: '100%',
        height: '100%',
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 24,
        backgroundColor: 'var(--gps-bg)',
      }}
    >
      {/* Barra indeterminada: nao existe <LinearProgress> sem MUI, entao a
          animacao (translateX indo e voltando) fica num <style> local - mesma
          solucao ja usada no Scrollbar deste lote para CSS que o Tailwind
          arbitrario nao cobre bem (keyframe nomeado). */}
      <style>{`
        @keyframes gps-loading-bar {
          0% { left: -40%; width: 40%; }
          50% { left: 30%; width: 45%; }
          100% { left: 100%; width: 40%; }
        }
      `}</style>

      <div style={{ position: 'relative', display: 'grid', placeItems: 'center' }}>
        {/* Halo que respira. Fica ATRAS do logo e nao gira: rotacao em elemento
            grande cansa a vista em espera longa. */}
        <m.div
          animate={{ scale: [1, 1.18, 1], opacity: [0.11, 0.0352, 0.11] }}
          transition={{ duration: 1.8, ease: 'easeInOut', repeat: Infinity }}
          style={{
            position: 'absolute',
            width: 132,
            height: 132,
            borderRadius: '50%',
            background: 'radial-gradient(circle, var(--gps-accent) 0%, transparent 70%)',
          }}
        />

        {/* Anel fino em volta, no ritmo inverso do halo: da profundidade sem
            competir com o logo. */}
        <m.div
          animate={{ scale: [1.06, 1, 1.06], opacity: [0.252, 0.126, 0.252] }}
          transition={{ duration: 1.8, ease: 'easeInOut', repeat: Infinity }}
          style={{
            position: 'absolute',
            width: 104,
            height: 104,
            borderRadius: '50%',
            border: '1.5px solid var(--gps-accent)',
          }}
        />

        <Logo disabledLink sx={{ width: 64, height: 64, position: 'relative' }} />
      </div>

      <div style={{ width: 168, textAlign: 'center' }}>
        <p
          style={{
            margin: 0,
            marginBottom: 10,
            fontWeight: 600,
            fontSize: '0.875rem',
            color: 'var(--gps-muted)',
            letterSpacing: '-0.01em',
          }}
        >
          Preparando seu painel
        </p>

        {/* Trilha + barra indeterminada fina: comunica progresso sem prometer
            prazo. Uma barra com porcentagem falsa e pior que nenhuma. */}
        <div
          style={{
            position: 'relative',
            height: 3,
            borderRadius: 3,
            overflow: 'hidden',
            backgroundColor: 'var(--gps-accent-soft)',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              height: 3,
              borderRadius: 3,
              backgroundColor: 'var(--gps-accent)',
              animation: 'gps-loading-bar 1.6s ease-in-out infinite',
            }}
          />
        </div>
      </div>
    </div>
  );
}
